import { useState } from "react"
import { BrowserRouter, Route, Routes } from "react-router-dom"
import { ToastContainer } from "react-toastify"
import LandingPage from "./components/sections/landingPage/LandingPage"
import RoutesFormDataContext from "./contexts/RoutesFormDataContext"
import { RoutesFormDataObject } from "./contexts/contextDataObjects/RoutesDataObject"
import Main from "./pages/Main"

function App() {
    const [routesFormData, setRoutesFormData] = useState(RoutesFormDataObject)

    return (
        <div>
            <RoutesFormDataContext.Provider
                value={{ routesFormData, setRoutesFormData }}
            >
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={<></>} />
                        <Route path="/studentaccident" element={<LandingPage />} />
                        <Route path="/studentaccident/policybooking" element={<Main />} />
                    </Routes>
                </BrowserRouter>
            </RoutesFormDataContext.Provider>
            <ToastContainer />

        </div >
    )
}

export default App
